export const MediumEnum = { PUSH: 'PUSH' } as const;

export type MediumType = typeof MediumEnum[keyof typeof MediumEnum];
